module.exports = __webpack_public_path__ + "img/Pista_21_2.46a0435e.png";